import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { Spinner, Container, Label, Input, Button,Progress,Nav, NavItem, NavLink, Col, Row, TabContent, TabPane, Table  } from 'reactstrap';
import { getSelectedMarketing } from '../../store/marketings/selectors';
import { IMarketing } from '../../store/interface';
import queryString from 'query-string'
// @ts-ignore
import { store } from 'react-notifications-component';
import DetailForm from './detailForm';
import BlobUtil from '../../utils/blobUtil';
import classnames from 'classnames';

// Organisers
import { getOrganisers } from '../../store/organisers/selectors';
import { listRequest as listRequestOrganisersAction} from '../../store/organisers/actions'

import { listRequest as listRequestAction,
    createRequest as createRequestAction,
    updateRequest as updateRequestAction,
    deleteRequest as deleteRequestAction,
    selectData as selectDataAction, 
    selectedData as selectedAction,
    selectedClear as selectedClearAction
} from '../../store/marketings/actions';
import MarketingTopNav from '../../components/marketingTopNav';

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    data: any
    ui : any
    dataOrganiser: any
}

interface IState {
    activeTab : string
    isNew: boolean
    newId : string
    modalOverwriteWarning: boolean
    selectedFile: any
    uploadProgress:number
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest : typeof listRequestAction
    createRequest : typeof createRequestAction
    updateRequest : typeof updateRequestAction
    deleteRequest : typeof deleteRequestAction
    selectData : typeof selectDataAction
    selectedData : typeof selectedAction
    selectedClear : typeof selectedClearAction
    listRequestOrganiser : typeof listRequestOrganisersAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class MarketingDetailPage extends React.Component<AllProps, IState> {
    fileUploadProgressInterval:any;
    blobUtil = new BlobUtil();

    constructor(props: AllProps) {
        super(props);
        this.state = {
            activeTab: '1',
            modalOverwriteWarning : false,
            isNew : false,
            newId : '',
            selectedFile : undefined,
            uploadProgress: 0
        };
        this.readData = this.readData.bind(this);
        this.createOrUpdateData = this.createOrUpdateData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.handleOverwriteWarning = this.handleOverwriteWarning.bind(this);
        this.uploadData = this.uploadData.bind(this);
    }

    public componentDidMount() {
        let id = this.props.route.match.params.id;
        if (id.toUpperCase() === "NEW"){
            this.setState({isNew: true, newId : this.generateId(6)});
        }else{
            this.props.selectData(id);
        }

        if (this.props.dataOrganiser.length === 0) {
            var searchParams:any = {};
            searchParams["term"] = "";
            searchParams["sorting"] = "";
            searchParams["offset"] = 0;
            searchParams["limit"] = 100;
            this.props.listRequestOrganiser(searchParams);
        }
    }
    public componentWillUnmount() {
        this.props.selectedClear();  
    } 

    generateId(length:number) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    readData(){
        const parsed = queryString.parse(this.props.route.location.search);
        var searchParams: any = {};
        searchParams["id"] = this.props.ui.selected;
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        this.props.listRequest(searchParams);
    }

    componentDidUpdate(prevProps: AllProps) {
        //console.log("componentDidUpdate : " + this.props.ui.selected);
        // Load data if direct access from link
        if (prevProps.ui.selected === undefined && this.props.ui.selected != undefined && this.props.data === undefined){
            this.readData();
        }

        // Load data to state for chanages
        if ((this.props.ui.processState !== 3) && (
            (prevProps.data === undefined && this.props.data !== undefined) || 
            //(this.props.ui?.selected !== "")
            (prevProps.data?.id !== this.props.data?.id)
            )){

            this.props.selectedData();
        }
        // Show notification
        if ((prevProps.data?._etag != this.props.data?._etag) || 
            (prevProps.ui.processState != this.props.ui.processState) ){
            let notification = { show : false, title:"", type: "", message : "" };

            if (this.props.ui.processState === 1){ // Create/Update success
                if (this.state.isNew){ // Added successfully
                    this.setState({isNew: false});
                    this.props.route.history.push('/marketings/' + this.props.ui.selected );
                }
                notification.show = true;
                notification.type = "success";
                notification.message = "Save successfully";
                
            } else if (this.props.ui.processState === 2){ // Create/Update failed
                if (this.props.ui.isConflict){
                    this.setState({ modalOverwriteWarning : true});
                } else {
                    this.setState({ modalOverwriteWarning : false});

                    notification.show = true;
                    notification.type = "danger";
                    notification.message =  "Process failed. Error : \n" + this.props.ui.errors;
                }
            } else if (this.props.ui.processState === 3){ // Delete success
                // Show custom dialaog box
            } else if (this.props.ui.processState === 4){ // Delete failed
                notification.show = true;
                notification.type = "danger";
                notification.message =  "Delete failed. Error : \n" + this.props.ui.errors;
            }

            if (notification.show){
                store.addNotification({
                    title: notification?.title ?? "Info",
                    message: notification.message,
                    type: notification.type,
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                }); 
            }
        }
    }
    
    handleSelectValue = (selectedValue: any) => {
        let val: any = []
        if(selectedValue) {
            selectedValue.forEach((element:any) => {
                val.push(element.label);
            });
        }
        return val;
    }
   
    createOrUpdateData = async (formData:any) => {

        let ruleLimitCourseArray:string[] = [];
        if (formData.ruleLimitCourse){
            formData.ruleLimitCourse.map((i:any)=>{
                ruleLimitCourseArray.push(i.value);
            })
        }

       if (this.state.isNew){
            const n : IMarketing = {
                id : "",
                promoCode : formData.promoCode,
                description : formData.description,
                startDate : formData.startDate,
                endDate : formData.endDate,
                discType : formData.discType,
                discAmount : formData.discAmount,
                discPct : formData.discPct,
                
                ruleAmtFrom : formData.ruleAmtFrom,
                ruleAmtTo : formData.ruleAmtTo,
                ruleLimitCourse : ruleLimitCourseArray,
                ruleLimitProfession : this.handleSelectValue(formData.ruleLimitProfession),
                ruleLimitOrganizer : this.handleSelectValue(formData.ruleLimitOrganizer),
                ruleLimitCountry : this.handleSelectValue(formData.ruleLimitCountry),

                ruleLimitUse : formData.ruleLimitUse,
                singleUserPerUser : formData.singleUserPerUser,

                searchKeywords : formData.promoCode.toLowerCase() + " " + formData.description.toLowerCase(),
                userLogs : []
            }
            this.props.createRequest(n);
        } else {
            let overwriteFlag = formData.Overwrite === "true"? true:false;
            this.props.updateRequest({
                id : this.props.ui.selected,
                promoCode : formData.promoCode,
                description : formData.description,
                startDate : formData.startDate,
                endDate : formData.endDate,
                discType : formData.discType,
                discAmount : formData.discAmount,
                discPct : formData.discPct,
                
                ruleAmtFrom : formData.ruleAmtFrom,
                ruleAmtTo : formData.ruleAmtTo,
                ruleLimitCourse : ruleLimitCourseArray,
                ruleLimitProfession : this.handleSelectValue(formData.ruleLimitProfession),
                ruleLimitOrganizer : this.handleSelectValue(formData.ruleLimitOrganizer),
                ruleLimitCountry : this.handleSelectValue(formData.ruleLimitCountry),

                ruleLimitUse : formData.ruleLimitUse,
                singleUserPerUser : formData.singleUserPerUser,
                searchKeywords : formData.promoCode.toLowerCase() + " " + formData.description.toLowerCase(),
                _etag : this.props.data._etag,
            });

            if (overwriteFlag === true){
                this.handleOverwriteWarning(); // Trigger close warning modal dialog
            }
        }
    }

    uploadData = async() => {
        this.blobUtil = new BlobUtil();
        this.startCheckProgress();
        let blobUrl = await this.blobUtil.UploadBlobToCointainer3(
            this.state.selectedFile.name,
            this.state.selectedFile,
            "images", "test"

        );
        this.stopCheckProgress();
        console.log("Blob URL : " + blobUrl);
    }

    startCheckProgress = () => {
        this.fileUploadProgressInterval = setInterval(() => {
          this.CheckProgress();
        }, 500);
    };
    
    CheckProgress = async () => {
        //console.log("===>" + this.blobUtil.getUploadProgress());
        this.setState({uploadProgress : this.blobUtil.getUploadProgress() });
    }

    stopCheckProgress = () => {
        clearInterval(this.fileUploadProgressInterval);
        this.setState({uploadProgress : 100 });
    }
    
    // On file select (from the pop up) 
    onFileChange = (event:any) => { 
        // Update the state 
        this.setState({ selectedFile: event.target.files[0] }); 
       
    }; 

    deleteData = async (doc:IMarketing) => {
        this.props.deleteRequest(doc);
    }
    
    handleOverwriteWarning(){
        this.setState({modalOverwriteWarning : !this.state.modalOverwriteWarning});
    }

    private toggle = (tab: any) => {
        if (this.state.activeTab !== tab){
            this.setState({ activeTab: tab });
        }
    }
    renderForm() {
        return (
            <DetailForm 
                props = {this.props} 
                read = {this.readData}
                save = {this.createOrUpdateData}
                remove = {this.deleteData}
                overwriteWarningFlag = {this.state.modalOverwriteWarning}
                overwriteHandleWarning = {this.handleOverwriteWarning}
                isNew = {this.state.isNew}
                newId =  {this.state.newId}
            />
        );
    }
    renderUseLog(){
        return (
            <Table>
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Order No</th>
                        <th>Course Id</th>
                        <th>Price</th>
                    </tr>
                </thead>
                <tbody>
                {
                    this.props.data?.userLogs.map((item :any) =>(
                        <tr key={item.id}>
                            <td>{item.emailAdd}</td>
                            <td>{item.orderNo}</td>
                            <td>{item.courseId}</td>
                            <td>{item.price.toFixed(2)}</td>                       
                        </tr>
                    ))
                }
            </tbody>
            </Table>
        );
    }

    public render() {
        return (
            <div className="bg-light container">
                {this.props.ui.loading ? 
                    (
                        <div>Loading data&nbsp;<Spinner color="warning">Loading</Spinner></div>
                    )
                    :
                    (
                        <Container>
                            {/* <MarketingTopNav activeTab = "Marketing" marketingId ={this.props.data?.id} isNew = {this.state.isNew} /> */}
                            <Nav tabs horizontal="true">
                                <NavItem>
                                    <NavLink 
                                        className={classnames({ active: this.state.activeTab === '1' })}
                                        onClick={() => { this.toggle('1'); }}
                                    >
                                        <i className="fas fa-bullhorn mr-1"></i>Promo
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '2' })}
                                        onClick={() => { this.toggle('2'); }}
                                    >
                                        <i className="fas fa-history mr-1"></i>Use Logs
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="1">
                                    <Row>
                                        <Col sm="12">
                                            {this.renderForm()}
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="2">
                                    <Row>
                                        <Col sm="12">
                                            {this.renderUseLog()}
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </Container>
                    )
                }
                
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.marketing.ui,
    data: getSelectedMarketing(state),
    dataOrganiser: getOrganisers(state),
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest : listRequestAction,
    createRequest : createRequestAction,
    updateRequest : updateRequestAction,
    deleteRequest : deleteRequestAction,
    selectData : selectDataAction,
    selectedData : selectedAction,
    selectedClear : selectedClearAction,
    listRequestOrganiser : listRequestOrganisersAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MarketingDetailPage)
